import SEO, {
  getOrganizationSchema,
  getWebSiteSchema,
  getWebPageSchema,
} from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import StatsSection from './components/StatsSection';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const title = '就要草视频 - 精选视频内容平台 | 海量精彩视频在线观看';
  const description =
    '就要草视频是您发现和观看优质视频内容的首选平台，汇聚海量精彩视频资源，涵盖电影、电视剧、综艺、动漫、纪录片等多种分类，提供流畅便捷的在线视频观看体验。';
  const keywords =
    '就要草视频,就要草视频在线观看,就要草视频最新资源,就要草视频高清播放,就要草视频免费观看,草视频精选内容,在线视频平台推荐';
  const canonicalUrl = 'https://jiuyaocao.com/';

  return (
    <>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={canonicalUrl}
        ogImage="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20massive%20screen%2C%20warm%20coral%20and%20amber%20lighting%2C%20luxurious%20atmosphere%2C%20premium%20cinema%20experience%2C%20movie%20platform%20branding&width=1200&height=630&seq=og-home-01&orientation=landscape"
        jsonLd={[
          getOrganizationSchema(),
          getWebSiteSchema(),
          getWebPageSchema(title, description, canonicalUrl),
        ]}
      />

      <main>
        <h1 className="sr-only">就要草视频 - 精选视频内容平台</h1>
        <HeroSection />
        <CategoryGrid />
        <FeaturedVideos />
        <StatsSection />
        <LatestArticles />
      </main>
    </>
  );
}